import * as React from 'react';
import { observer } from 'mobx-react';
import Content from './Content';
import ModalStore from '../../../../../../../Modal/Store';
import { Succeeded } from '../../Store/Types';
import Head from './Head';

interface Props {
  modalStore: ModalStore;
  state: Succeeded;
}

const Success: React.FC<Props> = ({ modalStore, state }) => {
  return (
    <>
      <Head />
      <Content state={state} modalStore={modalStore} />
    </>
  );
};

export default observer(Success);
